module.exports = __webpack_public_path__ + "media/images/icon_list/error-e97bcd45be4345a7402a03a625bb1254.svg";